import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiBoOperationsFilter, ApiOmpBoAvOperation, ApiOmpBoOperation } from "./types";

interface ApiBoAvOperationWire {
    Botype: number;
    Code: number;
    CurrentState: number;
    NextState: number;
    name: string;
}

interface BoAvOperationsResponse {
    operations: ApiBoAvOperationWire[];
}

interface BoOperationsListResponse {
    listData: ApiOmpBoOperation[];
}

/**
 * Транспортный слой OMP — операции над БО.
 */
export const boOperationsApi = {
    /**
     * Возвращает доступные операции для конкретного экземпляра БО.
     * Запрос уходит в endpoint `bo.avOperations`.
     * @param params идентификатор БО
     * @param config конфигурация HTTP-запроса
     * @returns список операций, которые разрешены в текущем состоянии БО
     */
    loadAvailable: async (params: { boCode: number }, config?: RequestConfig): Promise<ApiOmpBoAvOperation[]> => {
        const data = await ompApiClient.postOmega<BoAvOperationsResponse>("bo.avOperations", params, config);
        return data.operations.map((item) => {
            const { name, ...rest } = item;
            return {
                ...rest,
                Name: name,
            };
        });
    },

    /**
     * Возвращает справочник операций БО по фильтру.
     * Запрос уходит в endpoint `bo/operations.loadListByFilter`.
     * @param flt фильтр операций
     * @param config конфигурация HTTP-запроса
     * @returns список операций БО
     */
    load: async (flt: ApiBoOperationsFilter, config?: RequestConfig): Promise<ApiOmpBoOperation[]> => {
        const data = await ompApiClient.postOmega<BoOperationsListResponse>(
            "bo/operations.loadListByFilter",
            { flt },
            config,
        );
        return data.listData;
    },

    /**
     * Выполняет операцию жизненного цикла над БО.
     * Запрос уходит в endpoint `bo.performOperation`.
     * @param operationCode код операции
     * @param boCode код экземпляра БО
     * @param config конфигурация HTTP-запроса
     */
    perform: async (operationCode: number, boCode: number, config?: RequestConfig): Promise<void> => {
        await ompApiClient.postOmega(
            "bo.performOperation",
            {
                boCode,
                operCode: operationCode,
            },
            config,
        );
    },
} as const;
